import BaseComponent from 'foundation/base-component';
import React from 'react';
import { render } from 'react-dom';
import ObjectHelper from 'foundation/object-helper';
import BasketController from '../../../general/js/basket/basket-controller';
import TicketBuilder from './ticket-builder';
import basketProductsHelper from '../../../general/js/basket/basket-products-helper';
import {
    SCENARIO_HOSPITALITY,
    SCENARIO_HOSPITALITY_WITH_EXTRAS,
    SCENARIO_PARKING,
    SCENARIO_PARKING_STANDALONE,
    SCENARIO_STANDARD,
    SCENARIO_STANDARD_WITH_EXTRAS
} from './constants';
import gtm, { ecommerceEventTypes } from '../../../general/js/gtm';
import { CURRENCY_RATIO } from '../../../general/js/basket/currency-helper';

export default class TicketBuilderComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.data = {};

        try {
            this.data = JSON.parse(this.getAttribute(this.refs.data, 'options'));
        } catch (error) {
            console.log(error.message);
        }

        if (!this.data) {
            console.log('No data found');
            return;
        }

        const category = this.data.categories[0];

        gtm.pushEcommerceEvent(ecommerceEventTypes.VIEW_ITEM_LIST, {
            item_list_id: category.id,
            item_list_name: category.title,
            items: category.productGroups.map((productGroup) => ({
                item_id: productGroup.products[0].productId,
                item_name: `${productGroup.tag} - ${productGroup.title}`,
                price: productGroup.products[0].price / CURRENCY_RATIO,
                quantity: 1
            }))
        });

        const secutixProductsList = this.getBallotProductsList(this.data.secutixProductsGroups);
        const dialogBoxMessage = this.data.dialogBoxMessage.split('newline').join('\n');
        basketProductsHelper.setSecutixReservedProducts(secutixProductsList);
        render(
            (
                <BasketController
                    isConfiguredForBallot={this.data.isConfiguredForBallot}
                    redirectToBasketOnPay={this.data.redirectToBasketOnPay}
                    basketUrl={this.data.basketUrl}
                    masterCardDiscount={this.data.masterCardDiscount}
                    render={({
                        basket, onProductGroupsUpdate, onUpdateProductQuantity, onCheckout
                    }) =>
                        <TicketBuilder basket={basket}
                            onProductGroupsUpdate={onProductGroupsUpdate}
                            onUpdateProductQuantity={onUpdateProductQuantity}
                            onCheckout={onCheckout}
                            categoriesList={this.getCategoriesList(this.data.categories)}
                            dictionary={this.data.info}
                            currentScenario={this.getCurrentScenario()}
                            basketUrl={this.data.basketUrl}
                            isParkingStandaloneConfiguration={this.data.isParkingStandaloneConfiguration}
                            dialogBoxTitle={this.data.dialogBoxTitle}
                            dialogBoxMessage={dialogBoxMessage}
                            dialogBoxLogo={this.data.dialogBoxLogo}
                            dialogBoxBanner={this.data.dialogBoxBanner}
                            showDialogBox={this.data.showDialogBox}
                            quantityModifier={this.data.quantityModifier}
                        />
                    }>
                </BasketController>
            ),
            this.refs.section
        );
    }

    getCategoriesList(categoriesList) {
        if (!categoriesList || !categoriesList.length) return [];

        const newCategoriesList = ObjectHelper.clone(categoriesList);

        newCategoriesList.forEach((categorie) => {
            categorie.productGroups = categorie.productGroups.sort((a, b) =>
                a.sortOrder - b.sortOrder);
        });

        return newCategoriesList;
    }

    getBallotProductsList(ballotProductsList) {
        if (!ballotProductsList || !ballotProductsList.length) return [];

        const newCategoriesList = ObjectHelper.clone(ballotProductsList);

        newCategoriesList.forEach((categorie) => {
            categorie.products = categorie.products.sort((a, b) =>
                a.sortOrder - b.sortOrder);
        });

        return newCategoriesList;
    }

    getCurrentScenario() {
        const stepsData = this.getStepsData();
        let scenario = SCENARIO_STANDARD;

        if (stepsData.hasTickets) {
            scenario = SCENARIO_STANDARD;
        }

        if (stepsData.hasHospitality) {
            scenario = SCENARIO_HOSPITALITY;
        }

        if (stepsData.hasHospitality && (
            stepsData.hasExtras ||
            stepsData.hasParking
        )) {
            scenario = SCENARIO_HOSPITALITY_WITH_EXTRAS;
        }

        if (stepsData.hasTickets && !stepsData.hasHospitality && stepsData.hasExtras) {
            scenario = SCENARIO_STANDARD_WITH_EXTRAS;
        }

        if (!stepsData.hasTickets &&
            !stepsData.hasHospitality &&
            stepsData.hasParking &&
            !stepsData.isParkingStandaloneConfiguration
        ) {
            scenario = SCENARIO_PARKING;
        }

        if (!stepsData.hasTickets &&
            !stepsData.hasHospitality &&
            stepsData.hasParking &&
            stepsData.isParkingStandaloneConfiguration
        ) {
            scenario = SCENARIO_PARKING_STANDALONE;
        }

        return scenario;
    }

    getStepsData() {
        return {
            hasTickets: this.data.hasTickets || false,
            hasHospitality: this.data.hasHospitality || false,
            hasExtras: this.data.hasExtras || false,
            hasParking: this.data.hasParking || false,
            isParkingStandaloneConfiguration: this.data.isParkingStandaloneConfiguration || false,
            isConfiguredForBallot: this.data.isConfiguredForBallot || false
        };
    }
}
